import { jsx as _jsx } from "react/jsx-runtime";
import { ConstituentLogo } from '@modules/constituents/constituent-logo/constituent-logo';
export function IdeProvisionerLogo(props) {
    const { className } = props;
    return _jsx(ConstituentLogo, { id: "idep", className: className });
}
